class StickyMobilePdp extends HTMLElement {
    constructor() {
        super();
        this.currentATCButton = document.querySelector("[data-price-show-button]").firstElementChild;
        this.productGallery = document.querySelector(".splide.product-gallery");
        this.suscribeWidget = document.querySelector("[data-v-app]");
        this.reviewSection = document.querySelector(".product__rating.block-for-widget-blocks.block");
        this.bundlesReviewSection = document.querySelector(".product__rating");
        this.pdpDiscountBanner = document.querySelector(".dgf-tag-wrp");

        this.stickyAtc = document.querySelector(".sticky-container");
        this.selectShadeBtn = document.querySelector(".sticky-select-shade-btn");
        this.addToCartBtn = document.getElementById("sticky-add-to-cart-button-id");
        this.shadeContent = document.querySelector(".sticky-selected-shade-container");
        this.shadeVariantOptions = document.querySelectorAll("li[data-variant-id-pdp]");
        this.imageElement = this.querySelector(".sticky-shade-img");
        this.shadeTitleElement = this.querySelector(".sticky-product-shade_title");
        this.isStickyVariant;

        document.addEventListener("intelligems:loaded", ()=> {
            this.testStickyAtcVariant = window.testStickyAtcVariant || "orginial-test-variant";
            this.isStickyVariant = this.testStickyAtcVariant === "sticky-atc-variant";
        });
    }

    connectedCallback(){
        document.addEventListener("intelligems:loaded", ()=> {
            try {
                if(this.isStickyVariant) {
                    this.setStickyAtc();
                } else {
                    this.hideStickyAtc();
                }
            } catch (error) {
                console.error("Error on Sticky add to cart intelligems implementation: loaded event listener:", error);
            }
        });
    }

    setStickyAtc() {
        try {
            const currentUrl = window.location.href;
            const isAGiftCardPage = currentUrl.includes("gift-card")
            const isSoldOut = this.currentATCButton.hasAttribute("disabled");

            if(this.reviewSection) {
                const productTitleEl = document.querySelector(".font-heading");
                const stickyReviewSection = this.reviewSection.cloneNode(true);
                this.reviewSection.style.display = "none";
                stickyReviewSection.setAttribute("class", "sitcky-atc-reviews-test");
                this.pdpDiscountBanner ? stickyReviewSection.style.marginTop = "30px" :  stickyReviewSection.style.marginTop = "0px";
                productTitleEl.append(stickyReviewSection);

                const observer = new MutationObserver((mutations) => {
                    mutations.forEach((mutation) => {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === 1 && node.classList.contains("dgf-tag-wrp")) {
                                stickyReviewSection.style.marginTop= '20px !important';
                                observer.disconnect(); 
                            }
                        });
                    });
                });
                observer.observe(document.body, { childList: true, subtree: true });
                
            };

            if(this.bundlesReviewSection) {
                this.bundlesReviewSection.style.margin = "0 auto";
            }
        

            if(currentUrl && isAGiftCardPage) {
                this.hideStickyAtc();
            }
                
            if(isSoldOut) {
                this.hideStickyAtc();
            }
                
            document.addEventListener("scroll", ()=> {
                if (window.scrollY  > 200) {
                    this.stickyAtc.classList.add("show");
                } else {
                    this.stickyAtc.classList.remove("show");
                }
            });

            this.updatePrice();

            if(!this.selectShadeBtn) { return }
                    
            this.selectShadeBtn.addEventListener("click", ()=> {
                this.productGallery.scrollIntoView({ behavior: "smooth", block: "start" });
            });

            this.shadeVariantOptions.forEach(option => {
                option.addEventListener("click", () => {
                this.updateShade(option);
                });
            });
        } catch (error) {
            console.error("Error on render the Sticky add to cart on PDP:", error);
        }
    }

    updateShade(option) {
        try {
        const newShadeImage = option.querySelector('img');
        const newShadeTitle = newShadeImage.getAttribute('alt');
        const  capitalizeFormat = (str) => { return str.split(" ") .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ")};

        if(!newShadeImage && !newShadeTitle) {
            retrun;
        }

        if (newShadeImage && newShadeTitle) {
            this.imageElement.src = newShadeImage.getAttribute("src");
            this.imageElement.alt = newShadeTitle;
            this.shadeTitleElement.innerHTML = capitalizeFormat(newShadeTitle);
        }

        this.addToCartBtn.style.display= "block";
        this.selectShadeBtn.style.display= "none";
        this.shadeContent.style.display= "flex";
        } catch (error) {
            console.error("Error on updtate the shade on Sticky add to cart:", error);
        };
    }

    updatePrice() {
        try {
            function observerVariantChanged () {
                const currentUrl = window.location.href;
                if(currentUrl.includes("products/quad-on-go-hero-set")) {
                    return;
                }
                
                const buttonEl = document.querySelector("[data-price-show-button]");
                const observer = new MutationObserver(() => {
                    const getAllBtnValues = buttonEl.querySelectorAll("span"); 
                    const activeSpan =  Array.from(getAllBtnValues).find(itemSpan => itemSpan.classList.contains("active"));
                    const newActiveSpan = activeSpan.cloneNode(true);
                    const stickyPriceContainerEl = document.querySelector(".sticky-price-container");
                    const hasDiscountPriceProduct = newActiveSpan.childElementCount > 1;
                    stickyPriceContainerEl.innerHTML = ""; 

                    const setStyleTextToPrice = (element) => {
                        element.style.color = "#00263a";
                        element.style.fontSize = "14px";
                    };

                    if(hasDiscountPriceProduct){
                        stickyPriceContainerEl.appendChild(newActiveSpan);
                        const currentPrice = stickyPriceContainerEl.querySelector(".text-base-sale-price");
                        const discountPrice = stickyPriceContainerEl.querySelector("del")

                        /* CURRENT PRICE STYLE */
                        setStyleTextToPrice(currentPrice);
                        currentPrice.style.fontWeight=  "700";

                        /* DISCOUNT PRICE STYLE */
                        setStyleTextToPrice(discountPrice);
                        discountPrice.style.textDecorationLine = "line-through";
                    } else {
                        stickyPriceContainerEl.appendChild(newActiveSpan);
                        const currentPrice = stickyPriceContainerEl.querySelector("span");

                        /* CURRENT PRICE STYLE */
                        setStyleTextToPrice(currentPrice);
                        currentPrice.style.fontWeight=  "700";
                    }
                });
                observer.observe(buttonEl, { attributes: true, subtree: true, attributeFilter: ["class"] });
            }
            observerVariantChanged();

            if(!this.suscribeWidget) {
                return 
            }
        } catch(error) {
            console.error("Error on updte price value in the Sticky add to cart on PDP:", error);
        }
    }

    hideStickyAtc() {
        try{
            document.querySelector(".test-sticky-original-btn").style.display = "block";
            document.getElementById("sticky-mobile-pdp").remove();
            const isMobile = window.matchMedia("(max-width: 768px)").matches;
        
            if(isMobile) {
                this.reviewSection.style.display = "inline-block";
            }
        } catch(error) {
            console.log("Error on hidding the Sticky add to cart on PDP ", error);
        };
    }
}

customElements.define("sticky-mobile-pdp", StickyMobilePdp);